<template>
  <div>
    <h1>Logging out...</h1>
  </div>
</template>
<script>
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
import { clearAllAuthCookies } from "@/utils/cookieBackup";

export default {
  name: "Logout",
  data() {
    return {
      token: localStorage.getItem("access_token"),
    };
  },
  mounted() {
    this.logoutUser();
  },
  methods: {
    async logoutUser() {
      try {
        const response = await fetch(`${apiUrl}/logout`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
          },
        });

        const res = await response.json();
        console.log(response.status);

        if (response.status === 401 || response.status === 403) {
          //console.log(response.status);
        } else {
          //console.error(response.status);
        }
        localStorage.removeItem("access_token");
        localStorage.removeItem("expires_in");
        localStorage.removeItem("access_token_vr");
        clearAllAuthCookies();
        this.$router.push("/login");
      } catch (error) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("expires_in");
        localStorage.removeItem("access_token_vr");
        clearAllAuthCookies();
        this.$router.push("/login");
      }
    },
  },
};
</script>
<style scoped>
.form-control {
  height: 55px;
  font-size: 19px;
  width: 100%;
}
</style>
